import { render, staticRenderFns } from "./datacenter.vue?vue&type=template&id=3544f2fe&"
import script from "./datacenter.vue?vue&type=script&lang=js&"
export * from "./datacenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports